// This icon file is generated automatically.
var BeDepentFilled = { "icon": { "tag": "svg", "attrs": { "preserveAspectRatio": "xMidYMid", "viewBox": "0 0 200 200", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M152.16 176.88a19.02 19.02 0 01-18.64 16.11H23.89C13.46 193 5 184.36 5 173.71V40.39c0-9.64 6.95-17.64 16.02-19.06-.14.97-.22 1.96-.22 2.95V157.6c0 10.64 8.46 19.27 18.9 19.28h112.46zM55.49 5h109.6c10.45 0 18.9 8.63 18.9 19.28v117.2c0 10.66-8.46 19.28-18.9 19.28H55.5c-10.44 0-18.9-8.63-18.9-19.28V24.28C36.59 13.63 45.05 5 55.49 5z", "fill-rule": "evenodd" } }] }, "name": "be-depent", "theme": "filled" };
export default BeDepentFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/BeDepentFilled.js
// module id = 2058
// module chunks = 0